import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPage: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto px-6 py-24 animate-fade-in">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <p className="text-xs tracking-widest uppercase text-nude mb-3">
          Legal
        </p>
        <h1 className="font-serif text-5xl text-primary mb-12">
          Privacy Policy
        </h1>

        <div className="space-y-10 text-sm text-secondary leading-relaxed tracking-wide">
          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Information We Collect
            </h2>
            <p>
              We collect information you provide directly to us, such as when
              you create an account, make a purchase, or contact us for
              support. This includes your name, email address, shipping
              address, payment information, and any other information you
              choose to provide.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              How We Use Your Information
            </h2>
            <p className="mb-4">
              We use the information we collect to process transactions, send
              transactional and promotional communications, and improve our
              services.
            </p>
            <p>
              We do not sell, trade, or otherwise transfer your personally
              identifiable information to third parties without your consent,
              except as described in this policy.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Data Security
            </h2>
            <p>
              We implement appropriate technical and organizational measures
              to protect your personal information against unauthorized
              access, alteration, disclosure, or destruction. All payment
              information is encrypted using SSL technology.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Cookies
            </h2>
            <p>
              We use cookies to enhance your experience on our website,
              analyze site traffic, and personalize content. You can control
              cookies through your browser settings.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Your Rights
            </h2>
            <p>
              You have the right to access, correct, or delete your personal
              information at any time. To exercise these rights, please
              contact us at privacy@lanresavage.com.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Contact Us
            </h2>
            <p>
              If you have any questions about this Privacy Policy, please
              contact us at privacy@lanresavage.com or write to us at our
              registered address.
            </p>
          </div>

          <p className="text-xs text-nude">
            Last updated: January 2026
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default PrivacyPage;